import React, { PureComponent } from 'react'
import PropTypes                from 'prop-types'
import MajorItem                from '../MajorItem/indexNew'
import './index.less'
import {getSessionData} from "../../api/school";

class MajorList extends PureComponent {

  static propTypes = {
    classifyList: PropTypes.array,
    onMajorClick: PropTypes.func,
    rightIcon: PropTypes.func,
  }

  state = {
    openedId: null,
  }
  componentDidMount() {
    let wishClassifyId=getSessionData('wish-classifyId');
    let wishClassifyPosition=getSessionData('wish-classifyId-position');
    if(wishClassifyId&&(wishClassifyPosition||wishClassifyPosition==0)){
      this.setState({openedId:wishClassifyId});
      let main=document.getElementsByTagName('main')[0];
      main.scrollTo(0,wishClassifyPosition)
    }
  }

  getMajors(classifyId) {
    const { openedId } = this.state
    if (openedId === classifyId) {
      this.setState({
        openedId: null,
      })
    } else {
      this.setState({
        openedId: classifyId,
      })
    }
  }

  renderMajorList(list,classifyId) {
    const { onMajorClick, rightIcon } = this.props;
    if (Array.isArray(list)) {
      return list.map((d, i) =>
        <MajorItem
          key={i}
          major={d}
          onClick={onMajorClick}
          rightIcon={rightIcon}
          classifyId={classifyId}
        />
      )
    }
  }

  render() {
    const { openedId } = this.state
    const { classifyList, rightIcon } = this.props
    return classifyList.map((d, i) => (
      <div className="classify" key={i} id={d.id}>
        <div className="classify-item" onClick={this.getMajors.bind(this, d.id)}>
          {openedId === d.id
            ? <svg className="icon icon-indicator_1">
              <use xlinkHref="#icon-indicator_1"/>
            </svg>
            : <svg className="icon icon-indicator_2">
              <use xlinkHref="#icon-indicator_2"/>
            </svg>}
          <h4>{d.name}</h4>
          <span>{d.children.length}个专业</span>
          {rightIcon ? rightIcon(d) : null}
        </div>
        {openedId === d.id && <div className="major-list">{this.renderMajorList(d.children,d.id)}</div>}
      </div>
    ))
  }
}

export default MajorList



// WEBPACK FOOTER //
// ./src/components/MajorList/indexNew.js